import { TransparentButton, Typography } from '@libs/components';
import { CircleCheckIcon, CirclePendingIcon } from 'src/assets';
import styled from 'styled-components';
type ProcessProps = {
  isWaiting?: boolean;
};
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  padding: 0 1.6rem 1.6rem;
`;
export const IdContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.surface.disabled};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.x3};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.x3};
  padding: 0.8rem 1.6rem;
  width: 22rem;
  gap: 0.8rem;
  span {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;
export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.x32};
  background-color: ${({ theme }) => theme.colors.surface.default};

  padding: 0.6rem 0.8rem;
  gap: 0.8rem;
  margin: 1.2rem 0;
`;
export const AssetInfoTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.6rem;
  border-radius: ${({ theme }) => theme.borderRadius.x3};
  background-color: ${({ theme }) => theme.colors.surface.default};
  box-shadow: ${({ theme }) => theme.shadows.xl};
`;
export const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.2rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};
  gap: 0.4rem;
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    border: none;
    padding-bottom: 0;
  }
`;
export const FlexColumnGap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;
export const AssetIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0.8rem;
`;
export const Image = styled.img`
  width: 3.4rem;
  height: 3.4rem;
`;
export const ActionButton = styled(TransparentButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: ${({ theme }) => theme.colors.surface.default};
  width: 2.6rem;
  height: 2.6rem;
  margin-right: 0.8rem;
`;
export const CustomPendingIcon = styled(CirclePendingIcon)`
  width: 1.5rem;
  height: 1.5rem;
  fill: ${({ theme }) => theme.colors.text.pending};
  margin-right: 0.5rem;
  path {
    fill: ${({ theme }) => theme.colors.text.pending};
  }
`;
export const CustomCheckIcon = styled(CircleCheckIcon)<ProcessProps>`
  width: 1.5rem;
  height: 1.5rem;
  fill: ${({ theme, isWaiting }) =>
    isWaiting ? theme.colors.text.success : theme.colors.text.secondary};
  margin-right: 0.5rem;
  path {
    fill: ${({ theme, isWaiting }) =>
      isWaiting ? theme.colors.text.success : theme.colors.text.secondary};
  }
`;
export const LottieWrapper = styled.div`
  width: 2.4rem;
  height: 2.4rem;
`;
export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
`;
export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Footer = styled.div`
  display: flex;
  flex-direction: column;

  border-radius: ${({ theme }) => theme.borderRadius.x3};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  margin-top: 1.2rem;
  width: 100%;
`;
export const FooterRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.6rem;
`;
export const SwapDetailsButton = styled(TransparentButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4.8rem;
  padding: 0 1.6rem;
  border-radius: ${({ theme }) => theme.borderRadius.x14};
  border: 1px solid ${({ theme }) => theme.colors.text.default};
  width: 100%;
`;
